export const getHdppDisplayedPreloadEvent = () => {
  return {
    eventMode: 'preload',
    category: {
      primaryCategory: 'hdpp content'
    },
    eventInfo: {
      eventName: 'hdpp display'
    },
    item: [{
      productInfo: {
        displayedProtectionPlan: true
      }
    }]
  };
};
